import axios from "axios"
import ogcParser from "ogc-parser"
export const resolveWMTS = xmlUrl => axios({ method: 'get', url: xmlUrl }).then(res => {
    try {
        const capabilities = ogcParser.wmts(res.data)
        return capabilities
    } catch (err) {
        return { code: -1, message: 'xml解析失败', err }
    }
}).catch(err => {
    return { code: 500, message: err.message };
});